module.exports = __webpack_public_path__ + "img/49.35b9dbaa.jpg";